module.exports = __webpack_public_path__ + "img/ticket.59918dbb.svg";